import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Paginator} from 'front-onceforall-core';
import ListItem from './listItem';

function OrganisationProjectListView(props) {
  if (props.error) {
    return <div className="card"><Translate value="error.generic"/></div>;
  }

  return (
    <div className="card">
      {props.loading && <div className="loading-overlay"/>}
      {props.totalCount === 0 ?
        <div className="table-without-result">
          <Translate value="project.noProjects"/>
        </div> :
        <>
          <table className="clickable-row">
            <thead>
              <tr>
                <td className="col-4 flex-shrink-1"><Translate value="project.name"/></td>
                <td/>
                <td className="col-3 flex-shrink-0"><Translate value="project.ownerOrganisation"/></td>
                <td className="col-1 flex-shrink-0"><Translate value="address.postCode"/></td>
                <td className="col-2 flex-shrink-0"><Translate value="address.city"/></td>
                <td className="col-1 flex-shrink-0"><Translate value="address.country"/></td>
                {props.showDossierState && <td><Translate value="dossier.state.title"/></td>}
              </tr>
            </thead>
            <tbody>
              {props.interventions.map(intervention => (
                <ListItem
                  key={`intervention-${intervention.interventionId}`}
                  intervention={intervention}
                  showDossierState={props.showDossierState}
                />
              ))}
            </tbody>
          </table>
          <Paginator
            totalItems={props.totalCount}
            pageSize={props.pageSize}
            currentPage={props.pageNumber}
            onChangePage={props.onPageChange}
          />
        </>
      }
    </div>
  );
}

OrganisationProjectListView.propTypes = {
  interventions: PropTypes.array.isRequired,
  pageNumber: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  showDossierState: PropTypes.bool
};

export default OrganisationProjectListView;
